/**
 * Available LOGO.com Resources
 */
export const ResourceNamesEnum = {
  Templates: 'templates',
  Palettes: 'palettes',
  Icons: 'icons',
  Fonts: 'fonts',
  Logos: 'logos',
  LogoPackage: 'logos/package',
  LogosEdit: 'logos/edit',
  Tags: 'tags',
  Hues: 'hues',
  Wordmark_fonts: 'wordmark_fonts',
  Slogan_fonts: 'slogan_fonts',
  Wordmark: 'wordmark',
  Slogan: 'slogan',
  Products: 'products',
  Skus: 'skus',
  Cart: 'cart',
  Items: 'cart/items',
  Coupon: 'cart/coupon',
  Catalog: 'catalog',
  Sites: 'sites',
}
